var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DropDown, FieldGroup } from '@/components';
import { fontFamily } from '@/constants';
export var FontFamilySettings = function (_a) {
    var theme = _a.theme, setTheme = _a.setTheme;
    var handleFontFamilyChange = function (fontFamily) {
        setTheme(function (prev) { return (__assign(__assign({}, (prev !== null && prev !== void 0 ? prev : {})), { fontFamily: fontFamily })); });
    };
    return (_jsx(FieldGroup, { label: 'Font Family', groupClassName: 'w-full sm:w-48', children: _jsx(DropDown, { options: fontFamily.map(function (font) { return ({ value: font, label: font }); }), onChange: function (selected) { return handleFontFamilyChange(selected.value); }, selectedOptionsValues: (theme === null || theme === void 0 ? void 0 : theme.fontFamily) ? { value: theme === null || theme === void 0 ? void 0 : theme.fontFamily, label: theme === null || theme === void 0 ? void 0 : theme.fontFamily } : undefined }) }));
};
